import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CompanyBuyerMarketing from '../containers/Company/buyer/Marketing';
import { CompanyBuyerLeadsContainer } from '../containers/Company/buyer/Leads';
import CompanyBuyerCriteria from '../containers/Company/buyer/Criteria';
import CompanyBuyerAddOnProject from '../containers/Company/buyer/AddOnProject';
import CompanyBuyerProjects from '../containers/Company/buyer/Projects';
import CompanyBuyerFund from '../containers/Company/buyer/Fund';
import CompanyBuyerCeo from '../containers/Company/buyer/Ceo';
import CompanyBuyerRetainer from '../containers/Company/buyer/Retainer';
import AddOnProjectCustomContainer from '../containers/Company/buyer/AddOnProjectCustom';

export default function CompanyBuyerRouting() {
  return (
    <Switch>
      <Route component={CompanyBuyerMarketing} path="/company/:companyId([0-9]+)/:companySlug?/buyer/marketing" />
      <Route component={CompanyBuyerLeadsContainer} path="/company/:companyId([0-9]+)/:companySlug?/buyer/leads" />
      <Route component={CompanyBuyerCriteria} path="/company/:companyId([0-9]+)/:companySlug?/buyer/criteria" />
      <Route
        component={AddOnProjectCustomContainer}
        path="/company/:companyId([0-9]+)/:companySlug?/buyer/add-on-project/:id"
        exact
      />
      <Route
        component={CompanyBuyerAddOnProject}
        path="/company/:companyId([0-9]+)/:companySlug?/buyer/add-on-project/"
        exact
      />
      <Route component={CompanyBuyerProjects} path="/company/:companyId([0-9]+)/:companySlug?/buyer/projects" />
      <Route component={CompanyBuyerFund} path="/company/:companyId([0-9]+)/:companySlug?/buyer/fund" />
      <Route component={CompanyBuyerCeo} path="/company/:companyId([0-9]+)/:companySlug?/buyer/ceo" />
      <Route component={CompanyBuyerRetainer} path="/company/:companyId([0-9]+)/:companySlug?/buyer/retainer" />
    </Switch>
  );
}
